export const API_URL = `${process.env.REACT_APP_STORE_URL}/api/v1`
export const MEDTRYCK_API_URL = `${process.env.REACT_APP_MEDTRYCK_API_URL}/api/v1`
